import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import CustomHeaderFooterQuery, {
	type CustomHeaderFooterQuery$data,
	type CustomHeaderFooterQuery$variables,
} from './__generated__/CustomHeaderFooterQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadCustomHeaderAndFooter(spaceKey: any): Promise<{
	data: CustomHeaderFooterQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<CustomHeaderFooterQuery$data, CustomHeaderFooterQuery$variables>({
		query: CustomHeaderFooterQuery,
		variables: {
			spaceKey,
		},
	});
}
